import { Data } from "../../../context/OperadorContext";
import { formatMoney } from "../../../utils/formatMoney";
import { Loader } from "../../generics/loader";

interface ListInfosProps {
  data: Data | null;
}

export default function ListInfos({ data }: ListInfosProps) {
  return (
    <div className="mt-2 flex w-[100%] space-x-4">
      {!data ? (
        <div className="flex w-[100%] items-center justify-center rounded-lg border p-4">
          <Loader />
        </div>
      ) : (
        <>
          <div className="grid grid-cols-2 gap-4 w-full mb-1">
            {/* Dados da Fila */}
            <div className="bg-white rounded-lg border border-gray-200 p-4 h-[6.5rem]">
              <h3 className="text-sm font-medium text-blue-600  border-l-4 border-blue-600 pl-2">Dados da Fila</h3>
              <div className="grid grid-cols-4 gap-4">
                <div>
                  <p className="text-lg font-bold text-gray-900">{data.a_cobrar}</p>
                  <p className="text-xs text-blue-600">Fila loja</p>
                </div>
                <div>
                  <p className="text-lg font-bold text-gray-900">{data.contratos}</p>
                  <p className="text-xs text-blue-600">Contratos</p>
                </div>
                <div>
                  <p className="text-lg font-bold text-gray-900"> {formatMoney(data.valor_vencido)}</p>
                  <p className="text-xs text-blue-600">Valor vencido</p>
                </div>
                <div>
                  <p className="text-lg font-bold text-gray-900"> {formatMoney(data.valor_a_vencer)}</p>
                  <p className="text-xs text-blue-600">Valor a vencer</p>
                </div>
              </div>
            </div>

            {/* Produção do dia */}
            <div className="bg-white rounded-lg border border-gray-200 p-4 h-[6.5rem]">
              <h3 className="text-sm font-medium text-red-600 border-l-4 border-red-600 pl-2">Produção do dia</h3>
              <div className="grid grid-cols-4 gap-4">
                <div className="bg-green-50 p-2 rounded">
                  <p className="text-lg font-bold text-gray-900">    {data?.producao ? data?.producao?.acionamentos : '-'}</p>
                  <p className="text-xs text-green-600">Acionados</p>
                </div>
                <div className="bg-yellow-50 p-2 rounded">
                  <p className="text-lg font-bold text-gray-900"> {data?.producao ? data?.producao?.agendamentos : '-'}</p>
                  <p className="text-xs text-yellow-600">Agendados</p>
                </div>
                <div className="bg-green-50 p-2 rounded">
                  <p className="text-lg font-bold text-gray-900">{data?.producao ? formatMoney(Number(data?.producao?.valor_agendado)) : 'R$ 0,00'}</p>
                  <p className="text-xs text-green-600">Valor Agendado</p>
                </div>
                <div></div>
              </div>
            </div>
          </div>

        </>
      )}
    </div>
  );
}
